import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import './UploadPrice.css';
import { useTranslation } from 'react-i18next';

const UploadPrice = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({ date: '', price_per_box: '', zone: 'norte' });
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setError(null);
    setSubmitting(true);
    try {
      const token = localStorage.getItem('access_token');
      await axios.post(`${API_BASE_URL}/prices/upload/`, formData, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      });
      setMessage(t('upload_success'));
      setFormData({ date: '', price_per_box: '', zone: 'norte' });
    } catch (err) {
      console.error('Error uploading price:', err);
      setError(t('upload_error'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="upload-price-container">
      <h2>{t('upload_price')}</h2>
      <p className="upload-subtitle">
        Registro de precio de mercado en tiempo real. Solo usuarios autorizados.
      </p>

      <form onSubmit={handleSubmit} className="upload-form">
        <label>
          {t('zone')}
          <select name="zone" value={formData.zone} onChange={handleChange}>
            <option value="norte">{t('zona_norte')}</option>
            <option value="sur">{t('zona_sur')}</option>
          </select>
        </label>

        <label>
          {t('date')}
          <input
            type="datetime-local"
            name="date"
            value={formData.date}
            onChange={handleChange}
            required
          />
          <span className="upload-hint">Fecha y hora del precio registrado</span>
        </label>

        <label>
          {t('price_per_box')} (USD)
          <input
            type="number"
            step="0.01"
            name="price_per_box"
            value={formData.price_per_box}
            onChange={handleChange}
            placeholder="Ej: 7.50"
            required
          />
          <span className="upload-hint">Precio en dólares por caja estándar</span>
        </label>

        <button type="submit" className="upload-submit-btn" disabled={submitting}>
          {submitting ? 'Enviando...' : t('submit_price')}
        </button>
      </form>

      {message && <div className="upload-success">{message}</div>}
      {error   && <div className="upload-error">{error}</div>}

      <div style={{ marginTop: 24 }}>
        <p style={{ fontSize: '0.75rem', color: '#4a6278', lineHeight: 1.7 }}>
          Los precios deben estar en USD · El precio corresponde a una caja estándar de
          banana ecuatoriana · Los datos se actualizan inmediatamente en el sistema
        </p>
      </div>
    </div>
  );
};

export default UploadPrice;
